<script setup lang="ts">
import { computed } from "vue";

import { useLayout } from "@/layout/common/composables/layout";

const { calculatedMenuMode } = useLayout();

const footerClass = computed(() => {
  const isCompact =
    calculatedMenuMode.value === "slim" ||
    calculatedMenuMode.value === "compact";

  return [
    "border-t border-surface bg-transparent transition-all duration-200",
    isCompact ? "px-2 py-3" : "px-3 py-4",
    "group-data-[state=collapsed]/sidebar-wrapper:overflow-hidden",
  ];
});
</script>

<template>
  <div :class="footerClass">
    <slot />
  </div>
</template>

